// extracted by mini-css-extract-plugin
export default {"callback-button":"npsModel_callback-button__OyPi7"};